<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="编码">
      <a-input v-model="form.data.code"/>
    </a-form-model-item>
    <a-form-model-item label="名称">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="详情">
      <a-input v-model="form.data.detail"/>
    </a-form-model-item>
    <div style="text-align: right">
      <a-space>
        <a-button
          type="primary"
          v-if="!sysDictDataId" @click="onAdd" :disabled="form.disabled">
          {{ $t('CREATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button
          type="primary"
          v-if="sysDictDataId" @click="onUpdate" :disabled="form.disabled">{{ $t('UPDATE') || '创建' }}
          <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
        </a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </div>
  </a-form-model>
</template>

<script>
import {
  _querySysDictDataById,
  _addSysDictData,
  _updateSysDictData,
} from '@/api/sys/sysDictDataApi';

async function getSysDictData() {
  const result = await _querySysDictDataById(this.sysDictId, this.sysDictDataId);
  if (result) {
    this.form.data.code = result.code;
    this.form.data.name = result.name;
    this.form.data.detail = result.detail;
    this.form.data.sysDictId = result.sysDictId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSysDictData(
        this.sysDictId,
        {
          code: this.form.data.code,
          name: this.form.data.name,
          detail: this.form.data.detail,
        },
      );
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateSysDictData(
        this.sysDictId,
        this.sysDictDataId,
        {
          code: this.form.data.code,
          name: this.form.data.name,
          detail: this.form.data.detail,
        },
      );
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'SysDictDataEdit',
  props: {
    sysDictId: String,
    sysDictDataId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sysDictDataId() {
      if (this.sysDictDataId) {
        this.getSysDictData();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getSysDictData,
  },
  data() {
    return {
      form: {
        data: {
          code: '',
          name: '',
          detail: '',
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sysDictDataId) {
      this.getSysDictData();
    }
  },
};
</script>
